import styled from 'vue-styled-components';
import HelpDeskIcon from '@svgIcons/help_desk.svg';
import { FLEX_VERTICAL_CENTER_DIV } from '@/styles/common.styled.component';
import qs from 'qs';

export default {
    name: 'HelpDesk',
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClick() {
            const url =
                this.language === 'ko'
                    ? 'https://share.hsforms.com/1Rnhg162KR9aZCFMZYKBRCgcfioh'
                    : 'https://share.hsforms.com/1WrAsY1JfQ_2uo5I01Tyg1Qcfioh';

            const queryStr = qs.stringify({
                ws_id: this.cAccountId,
                dashboard_url: window.location.href,
                user_id: this.globalUser?.id,
                email: this.globalUser?.email,
            });

            const fullUrl = `${url}?${queryStr}`;

            window.open(fullUrl, '_blank');
        },
    },
    render() {
        return (
            <Wrapper class="help-desk-wrapper" onClick={this.handleClick}>
                <HelpDeskIcon view-box="0 0 16 16" />
                <Text>{this.$t('COMMON.help_desk')}</Text>
            </Wrapper>
        );
    },
};

const Wrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    display: inline-flex;
    padding: 9px 12px;
    border-radius: 2px;
    border: 1px solid #bdc2c7;
    background: var(--gray-white, #fff);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        background: #f4f6f8;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

const Text = styled.span`
    color: #2a333d;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-left: 4px;
`;
